var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.904 10.473L24 12H12l-1.5-3h13.122c.123.48.218.972.282 1.473zM19.938 3c.972.858 1.803 1.87 2.457 3H10.5V3h9.438zM22.395 18c.537-.928.953-1.936 1.227-3H.378c.274 1.064.69 2.072 1.227 3h20.79zM19.938 21H4.063c.207.183.42.359.64.527l.209.157A11.946 11.946 0 0012 24c3.043 0 5.822-1.133 7.938-3z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12h12V0z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.804 5.67c.169-.272.348-.537.538-.794l.261.796h1.24l-1.003.722.394 1.2-1.03-.742-1.032.742.394-1.2-.129-.093c.116-.214.237-.424.365-.63l.002-.001zM4.974 2.27a12.023 12.023 0 011.302-.82l.124.378h1.24l-1.003.722.394 1.2L6 3.008l-1.031.742.394-1.2-.389-.28zM9.797 10.649l-1.031.742.394-1.2-1.004-.722h1.24l.4-1.219.401 1.219h1.24l-1.003.722.394 1.2-1.031-.742zM6 10.649l-1.031.742.394-1.2-1.004-.722H5.6L6 8.25l.4 1.219h1.24l-1.003.722.394 1.2L6 10.649zM2.203 10.649l-1.031.742.394-1.2-1.004-.722h1.24l.401-1.219.4 1.219h1.24l-1.003.722.394 1.2-1.03-.742zM9.797 6.852l-1.031.742.394-1.2-1.004-.722h1.24l.4-1.219.401 1.219h1.24l-1.003.722.394 1.2-1.031-.742zM6 6.852l-1.031.742.394-1.2-1.004-.722H5.6L6 4.453l.4 1.219h1.24l-1.003.722.394 1.2L6 6.852zM9.797 3.008l-1.031.742.394-1.2-1.004-.722h1.24l.4-1.219.401 1.22h1.24l-1.003.72.394 1.201-1.031-.742z",
    fill: "#EEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "us_svg__clip0_2003_27268"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.1d9ed001013fbf15a6027b1b3319a247.svg";
export { ForwardRef as ReactComponent };